import mapboxgl from "mapbox-gl";

export enum MapStyles {
	roadmap = 0,
	satellite = 1,
}

const style = [
	"emmetdel/cl9cvordb004715nl2c48vevd",
	"mapbox/satellite-streets-v11",
];

export const switchMapStyles = async (
	mapStyle: MapStyles,
	map: mapboxgl.Map,
) => {
	const response = await fetch(
		`https://api.mapbox.com/styles/v1/${style[mapStyle]}?access_token=${mapboxgl.accessToken}`,
	);
	const responseJson = await response.json();
	const newStyle = responseJson;

	const currentStyle = map.getStyle();
	// ensure any sources from the current style are copied across to the new style
	newStyle.sources = Object.assign({}, currentStyle.sources, newStyle.sources);

	// find the index of where to insert our layers to retain in the new style
	let labelIndex = newStyle.layers.findIndex((el) => {
		return el.id === "waterway-label";
	});

	// default to on top
	if (labelIndex === -1) {
		labelIndex = newStyle.layers.length;
	}
	const appLayers = currentStyle.layers.filter((el: any) => {
		// app layers are the layers to retain, and these are any layers which have a different source set
		return (
			el.source &&
			el.source !== "mapbox://mapbox.satellite" &&
			el.source !== "mapbox" &&
			el.source !== "composite"
		);
	});
	newStyle.layers = [
		...newStyle.layers.slice(0, labelIndex),
		...appLayers,
		...newStyle.layers.slice(labelIndex, -1),
	];
	map.setStyle(newStyle);
};

/*** Searching for a lat long in mapbox search  ***/
export const coordinatesGeocoder = (query) => {
	// Match anything which looks like
	// decimal degrees coordinate pair.
	const matches = query.match(
		/^[ ]*(?:Lat: )?(-?\d+\.?\d*)[, ]+(?:Lng: )?(-?\d+\.?\d*)[ ]*$/i,
	);
	if (!matches) {
		return null;
	}

	function coordinateFeature(lng, lat) {
		return {
			center: [lng, lat],
			geometry: {
				type: "Point",
				coordinates: [lng, lat],
			},
			place_name: `Lat: ${lat} Lng: ${lng}`,
			place_type: ["coordinate"],
			properties: {},
			type: "Feature",
		};
	}

	const coord1 = Number(matches[1]);
	const coord2 = Number(matches[2]);
	const geocodes = [];

	if (coord1 < -90 || coord1 > 90) {
		// must be lng, lat
		geocodes.push(coordinateFeature(coord1, coord2));
	}

	if (coord2 < -90 || coord2 > 90) {
		// must be lat, lng
		geocodes.push(coordinateFeature(coord2, coord1));
	}

	if (geocodes.length === 0) {
		// else could be either lng, lat or lat, lng
		geocodes.push(coordinateFeature(coord1, coord2));
		geocodes.push(coordinateFeature(coord2, coord1));
	}

	return geocodes;
};

// function to convert meters to feet
export const metersToFeet = (meters: number) => Math.round(meters * 3.28084);
